export default __webpack_public_path__ + "static/media/logo_pacifico.8829c358.png";